/* eslint-disable react/jsx-pascal-case */
import React, { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import "./index.less";
import { message, Tooltip } from "antd";
import { changeEgovUrl } from "@/utils/tools";
import IconFont from "@/components/icon";
interface ItemType {
  code: number;
  img?: any;
  png?: any;
  selected: boolean;
  text: string;
}

function CheckSelect(
  {
    priority,
    onRadioChange,
    onCheckboxChange,
    disable,
    type,
    min,
    customClass,
    defaultAllChecked = false,
    defaultChecked,
    hide,
    imgType = "png",
    isCreate,
    options = []
  }: {
    priority?: number;
    onRadioChange?: (priority: number) => void;
    onCheckboxChange?: (priority: number[]) => void;
    disable?: boolean;
    min?: number;
    type: string; // 单选radio 多选 checkbox
    customClass?: string;
    defaultChecked?: number[];
    defaultAllChecked?: boolean;
    sourceChangeType?: string;
    hide?: boolean;
    imgType?: string;
    isCreate?: boolean;
    options?: ItemType[];
  },
  ref: any
) {
  // 任务类型
  const [arr, setArr] = useState<ItemType[]>(options);

  if (defaultChecked && defaultChecked.length > 0) {
    arr.forEach((item) => {
      if (defaultChecked.includes(item.code)) {
        item.selected = true;
      }
    });
  }

  const [radio, setRadio] = useState(priority);
  useEffect(() => {
    setRadio(priority);
  }, [priority]);

  function handleClick(item: ItemType) {
    if (disable) {
      return;
    }
    if (type === "radio") {
      if (!onRadioChange) {
        return;
      }
      // 任务类型不能为空
      if (item.code === radio) {
        return;
      }
      setRadio(item.code);
      onRadioChange(item.code);
    } else {
      if (!onCheckboxChange) {
        return;
      }

      if (min && arr.filter((item) => item.selected).length <= min && item.selected) {
        message.warn(`至少选择${min}项`);
        return;
      }
      const targetList = arr.map((ele) => {
        if (item.code === ele.code) {
          ele.selected = !item.selected;
        }
        return ele;
      });
      setArr(targetList);
      onCheckboxChange(arr.filter((item) => item.selected).map((ele) => ele.code));
    }
  }
  useImperativeHandle(ref, () => {
    return {
      resetAllSelectStatus: () => {
        const targetList = arr.map((ele) => {
          ele.selected = false;
          return ele;
        });
        setArr(targetList);
      }
    };
  });
  let isPng = imgType === "png";
  return (
    <div>
      <ul className={`${customClass || "check-select-tabs"}`}>
        {arr.map((item) => (
          <li
            key={item.code}
            onClick={() => handleClick(item)}
            style={{
              cursor: disable ? "" : "pointer",
              display: hide && radio !== item.code ? "none" : "initial"
            }}
          >
            <Tooltip placement="bottom" title={item.text}>
              <span
                className={`${
                  (type === "radio" && radio === item.code) ||
                  (type === "checkbox" && item.selected)
                    ? "active"
                    : ""
                } type`}
                // title={item.text}
              >
                <IconFont className="icon-check" type="iconic_check" />
                {item.png || item.img ? changeEgovUrl(isPng ? item.png : item.img) : null}
                {item.text}
              </span>
            </Tooltip>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default forwardRef(CheckSelect);
